import { useState } from 'react';
import { Link } from 'react-router-dom';

interface HeaderProps {
  isScrolled?: boolean;
}

export default function Header({ isScrolled = false }: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo - Sol Üst Köşe */}
          <Link to="/" className="flex items-center gap-3 group">
            <img
              src="https://static.readdy.ai/image/e51399e73e35a4762b4f070880195b49/9b2e9a7aaab42a3100a70bae259ec8cb.jpeg"
              alt="Rota Berlin Logo"
              className="h-14 w-auto object-contain"
            />
            <span className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-600' : 'text-gray-200'}`}>
              Eğitim Danışmanlığı
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            <Link 
              to="/" 
              className={`font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-[#DD0000]' : 'text-white hover:text-[#FFCE00]'}`}
            >
              Ana Sayfa
            </Link>
            <Link 
              to="/about" 
              className={`font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-[#DD0000]' : 'text-white hover:text-[#FFCE00]'}`}
            >
              Hakkımızda
            </Link>
            <Link 
              to="/services" 
              className={`font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-[#DD0000]' : 'text-white hover:text-[#FFCE00]'}`}
            >
              Hizmetlerimiz
            </Link>
            <Link 
              to="/contact" 
              className={`font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-[#DD0000]' : 'text-white hover:text-[#FFCE00]'}`}
            >
              İletişim
            </Link>
            <a
              href="#randevu"
              className="px-5 py-2.5 bg-[#DD0000] text-white font-semibold rounded-lg hover:bg-[#bb0000] transition-all whitespace-nowrap cursor-pointer"
            >
              Randevu Al
            </a>
            <a
              href="tel:+902129126797"
              className="px-5 py-2.5 bg-[#FFCE00] text-[#1a1a1a] font-semibold rounded-lg hover:bg-[#e6b800] transition-all whitespace-nowrap flex items-center gap-2 cursor-pointer"
            >
              <i className="ri-phone-line text-lg"></i>
              İletişim
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
            }`}
            aria-label="Menu"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 py-4 rounded-b-xl shadow-lg">
            <nav className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-sm font-medium text-gray-700 hover:text-[#DD0000] hover:bg-gray-50 transition-colors px-4 py-3 rounded-lg"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Ana Sayfa
              </Link>
              <Link
                to="/about"
                className="text-sm font-medium text-gray-700 hover:text-[#DD0000] hover:bg-gray-50 transition-colors px-4 py-3 rounded-lg"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Hakkımızda
              </Link>
              <Link
                to="/services"
                className="text-sm font-medium text-gray-700 hover:text-[#DD0000] hover:bg-gray-50 transition-colors px-4 py-3 rounded-lg"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Hizmetlerimiz
              </Link>
              <Link
                to="/contact"
                className="text-sm font-medium text-gray-700 hover:text-[#DD0000] hover:bg-gray-50 transition-colors px-4 py-3 rounded-lg"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                İletişim
              </Link>
              <a
                href="#randevu"
                className="mx-4 mt-2 px-6 py-3 bg-[#DD0000] text-white text-sm font-semibold rounded-lg hover:bg-[#bb0000] transition-all text-center whitespace-nowrap cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Randevu Al
              </a>
              <a
                href="tel:+902129126797"
                className="mx-4 mt-2 px-6 py-3 bg-[#FFCE00] text-[#1a1a1a] text-sm font-semibold rounded-lg hover:bg-[#e6b800] transition-all text-center whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <i className="ri-phone-line text-lg"></i>
                İletişim
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
